import { faker } from "@faker-js/faker";

import { merge } from "@/__mocks__/mockHelpers";

interface ListMockItemProps {
  text: string;
}

interface TwoColumnListMockItemProps {
  left: string;
  right: string;
}

const fakeListMockItem = (
  overrides?: DeepPartial<ListMockItemProps>,
): ListMockItemProps => {
  const props: ListMockItemProps = {
    text: faker.lorem.sentence(),
  };
  return merge(props, overrides);
};

const fakeTwoColumnListMockItem = (
  overrides?: DeepPartial<TwoColumnListMockItemProps>,
): TwoColumnListMockItemProps => {
  const props: TwoColumnListMockItemProps = {
    left: faker.lorem.word(),
    right: faker.lorem.word(),
  };
  return merge(props, overrides);
};

const fakeSection = (
  overrides?: DeepPartial<Section<ListMockItemProps>>,
): Section<ListMockItemProps> => {
  const props: Section<ListMockItemProps> = {
    data: faker.helpers.multiple(() => fakeListMockItem(), {
      count: faker.number.int({ max: 5, min: 1 }),
    }),
    title: faker.lorem.words(faker.number.int({ max: 3, min: 1 })),
  };
  return merge(props, overrides);
};

export { fakeListMockItem, fakeSection, fakeTwoColumnListMockItem };
export type { ListMockItemProps, TwoColumnListMockItemProps };
